import { ref } from 'vue';

export const routeLoading = ref(false);

let routeLoadingTimer = null;

export function startRouteLoading() {
  clearTimeout(routeLoadingTimer);
  routeLoadingTimer = setTimeout(() => {
    routeLoading.value = true;
  }, 120);
}

export function stopRouteLoading() {
  clearTimeout(routeLoadingTimer);
  routeLoading.value = false;
}
